import * as React from "react"
import { HStack, Button } from "@chakra-ui/react"

export interface PaginationProps {
  isLoading: boolean
  page: number
  pageSize: number
  setPage: (page: number) => void
  count: number
}

export const Pagination: React.FC<PaginationProps> = (props) => {
  const numberOfPages = props.count ? Math.ceil(props.count / props.pageSize) : 0

  const pageArray = [...Array(numberOfPages)].map((_, i) => i)
  return (
    <HStack spacing={1}>
      <Button
        size="sm"
        variant="ghost"
        isDisabled={props.isLoading || props.page <= 1 || props.count === 0}
        onClick={() => props.setPage(props.page - 1)}
      >
        Prev
      </Button>
      {pageArray
        .slice(props.page > 3 ? props.page - 3 : 0, props.page > 3 ? props.page + 2 : 5)
        .map((page) => (
          <Button
            size="xs"
            key={page}
            variant={props.page === page + 1 ? "solid" : "ghost"}
            onClick={() => props.setPage(page + 1)}
          >
            {page + 1}
          </Button>
        ))}
      <Button
        size="sm"
        variant="ghost"
        isDisabled={
          props.isLoading ||
          props.count === 0 ||
          (!!props.count && props.count <= props.page * props.pageSize)
        }
        onClick={() => props.setPage(props.page + 1)}
      >
        Next
      </Button>
    </HStack>
  )
}
